module.exports = __webpack_public_path__ + "img/a-5.d4cdbdb0.png";